import Konva from 'konva';
import { NodeConfig } from 'konva/lib/Node';
import { memo, useLayoutEffect } from 'react';
import { Rect } from 'react-konva';

interface IAutoSizeRectProps extends NodeConfig {
  isActive: boolean;
  existedSizes: boolean;
  containerWidth: number;
  containerHeight: number;
  text: string;
  fontFamily?: string;
  fontSize: number;
  setContainerSizes: (width: number, height: number) => void;
}

export const AutoSizeRect: React.FC<IAutoSizeRectProps> = memo(
  ({
    isActive,
    existedSizes,
    containerWidth,
    containerHeight,
    fontFamily,
    fontSize,
    text,
    setContainerSizes,
    ...rectProps
  }) => {
    const padding = 4;

    useLayoutEffect(() => {
      if (existedSizes || !fontFamily) return;

      const textNode = new Konva.Text({ text, fontSize, fontFamily });

      const textWidth = textNode.width();
      const textHeight = textNode.height();

      setContainerSizes(Math.ceil(textWidth), Math.ceil(textHeight));

      textNode.remove();
    }, [
      containerHeight,
      containerWidth,
      existedSizes,
      fontFamily,
      fontSize,
      text,
      setContainerSizes,
    ]);

    return (
      <Rect
        width={containerWidth}
        height={containerHeight}
        x={rectProps.x}
        y={rectProps.y}
        stroke="#2680EB"
        visible={isActive}
        rotation={rectProps.rotation}
        strokeWidth={padding}
      />
    );
  }
);
